import { IconDownload } from 'featherico';
import { DOWNLOADS } from '../../../../routes';
import { preventJavascriptUrls } from '../../../../services/security';
import { prependAppPath } from '../../../services/Url';
import Button from '../../Button';
import { DeprecatedButtonContainer } from '../../ButtonContainer';
import Link from '../../Link';
import prettyFileSize from '../services/prettyFileSize';
import styles from './style.m.less';

export default function Result({ file, onClose }) {
    return (
        <div>
            <h1>Finished</h1>
            <p>
                Your export is available now. We also added it to the{' '}
                <Link href={prependAppPath(DOWNLOADS)}>latest exports</Link> page for future reference.
            </p>
            <Download {...file} />
            <DeprecatedButtonContainer>
                <Button onClick={onClose}>Close</Button>
            </DeprecatedButtonContainer>
        </div>
    );
}

function Download({ downloadPath, fileName, size }) {
    return (
        <div>
            <IconDownload />
            &nbsp;
            <b>
                <a href={preventJavascriptUrls(downloadPath)}>{fileName}</a>
            </b>
            &nbsp;
            <span className={styles.filesize}>({prettyFileSize(size)})</span>
        </div>
    );
}
